import { FC } from "react";
import { Link } from "react-router-dom";

const ImportantNoticeModal: FC<{ isModalVisible: boolean; onClose: () => void; }> = ( { isModalVisible, onClose } ): JSX.Element => {
  return (
    <div
      className={`modal fade ${isModalVisible ? 'show show-modal' : ''}`}
      style={{ backgroundColor: "rgba(0, 0, 0, 0)" }} onClick={onClose}
    >
      <div className="modal-dialog modal-lg" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content shadow">
          <div className="modal-header">
            <p className="modal-title h1 text-success">
              IMPORTANT UPDATE:
            </p>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body py-3 pb-4">
            <Link to="/pages/year_end_email" onClick={onClose}>
              IMPORTANT UPDATE: QUTENZA® (capsaicin) 8% Topical System Benefit Reverification Update
            </Link>
            {/* <p className="mb-0 fs-6">
              Effective 8/15/2025, MQC will continue to accept and complete all Benefit Investigation
              requests, however, prior authorization and appeal support will only be available for
              Diabetic Peripheral Neuropathy (DPN) of the feet and post-herpetic neuralgia (PHN)
            </p> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportantNoticeModal
